import { Reveal } from "@/components/Reveal";

export function ChapterHeading({ number, title, urdu, center = false, testId }) {
  return (
    <Reveal>
      <div className={center ? "text-center" : "text-left"}>
        <div className={`flex items-center gap-4 ${center ? "justify-center" : ""}`}>
          <span className="font-display text-lg text-[#D4AF37]">{number}</span>
          <span className="h-px w-12 bg-gradient-to-r from-[#D4AF37]/60 to-transparent" aria-hidden="true" />
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-[#D4AF37]/90 sm:text-sm">
            Chapter {number}
          </span>
        </div>
        <h2
          data-testid={testId}
          className="font-display mt-5 text-3xl leading-tight tracking-tight text-[#F7F4EF] sm:text-4xl lg:text-5xl"
        >
          {title}
        </h2>
        {urdu && (
          <p dir="rtl" lang="ur" className="font-urdu mt-3 text-2xl leading-relaxed text-[#D4AF37]/75">
            {urdu}
          </p>
        )}
      </div>
    </Reveal>
  );
}
